import { cn } from "@theprelude/core";

export const ScheduleIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 17.523 6.477 22 12 22C12.3375 22 12.6711 21.9833 13 21.9506V19.9373C12.67 19.9788 12.3361 20 12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12C4 9.87827 4.84285 7.84344 6.34315 6.34315C7.84344 4.84285 9.87827 4 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C19.1571 7.84344 20 9.87827 20 12H22C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12Z"
    />
    <path d="M18 14V17H15V19H18V22H20V19H23V17H20V14H18Z" />
    <path d="M17 12H13V7H11V14H17V12Z" />
  </svg>
);
